module.exports = __webpack_public_path__ + "travelstation-logo.png?39dc0f3a8f0fe75ca854c341123a760a";